export const getGarageEmailAddress = () => window.localStorage.getItem('garageEmailAddress');
